import { render, staticRenderFns } from "./superadmin_dashboard.vue?vue&type=template&id=3ab2c3fe&"
import script from "./superadmin_dashboard.vue?vue&type=script&lang=js&"
export * from "./superadmin_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./superadmin_dashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports